import { render, staticRenderFns } from "./CouncilActivity.vue?vue&type=template&id=1f636d08&scoped=true"
import script from "./CouncilActivity.vue?vue&type=script&lang=js"
export * from "./CouncilActivity.vue?vue&type=script&lang=js"
import style0 from "./CouncilActivity.vue?vue&type=style&index=0&id=1f636d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f636d08",
  null
  
)

export default component.exports